module.exports = __webpack_public_path__ + "1791188489487/images/logo_light.bbd6e65.png";